module.exports = __webpack_public_path__ + "img/jinri.d8bfbc7d.png";